import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subject, Observable, of } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap, catchError, tap } from 'rxjs/operators';
import { Report } from 'src/app/models/report.model';
import { DataService } from 'src/app/service/data.service';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class SearchComponent implements OnInit {
  private searchTerms = new Subject<string>();
  searchResults$: Observable<Report[]>;
  searchQuery: string = '';

  constructor(private dataService: DataService, private router: Router) {}

  ngOnInit(): void {
    this.searchResults$ = this.searchTerms.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      switchMap((term: string) => {
        if (term.length >= 3) {
          return this.dataService.searchReports(term);
        }
        return of([]); // Clear results if term is less than 3 chars
      }),
      catchError(error => {
        console.error('Error fetching search results:', error);
        return of([]);
      })
    );
  }

  search(term: string): void {
    this.searchTerms.next(term.trim());
  }

  onSelect(report: Report): void {
    this.searchQuery = '';
    this.searchTerms.next(''); // Clear results
    this.router.navigate(['/report', report.id]);
  }
}
